import React, { Component } from 'react';
import Button from 'react-bootstrap/lib/Button';
import pick from 'lodash/pick';
import { inject } from 'mobx-react';

@inject('batchStore')
class NormalButton extends Component {
  onMouseDown = e => {
    // stop bubbling to prevent unexpected dragging
    e.stopPropagation();
  };

  onClick = () => {
    const { port, duration, delay = 0, disabled = false, batchStore, onClick = () => {} } = this.props;

    if (port && !disabled) {
      clearTimeout(this[`timer-${port}`]);

      this[`timer-${port}`] = setTimeout(() => {
        batchStore.setOutput(port, duration);
      }, delay * 1000);
    }

    if (!disabled) {
      onClick();
    }
  };

  render() {
    const allowedProps = pick(this.props, ['bsStyle', 'bsSize', 'className']);

    return (
      <Button
        bsSize="sm"
        disabled={this.props.disabled}
        bsStyle="primary"
        {...allowedProps}
        onMouseDown={this.onMouseDown}
        onClick={this.onClick}
      >
        {this.props.children || <i className="fa fa-arrow-down" />}
      </Button>
    );
  }
}

export default NormalButton;
